export var createWebhooksApi = function (baseUrl, http) {
    return {
        getWebhooks: function () { return http.get("".concat(baseUrl, "/webhooks")); },
        addWebhook: function (dto) { return http.post("".concat(baseUrl, "/webhooks"), dto); },
        updateWebhook: function (dto) { return http.put("".concat(baseUrl, "/webhooks/").concat(dto.id), dto.data); },
        deleteWebhook: function (id) { return http.delete("".concat(baseUrl, "/webhooks/").concat(id)); }
    };
};
//# sourceMappingURL=index.js.map